module.exports = __webpack_public_path__ + "static/img/2.9299108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6/2.png
// module id = tlIT
// module chunks = 1